export default __webpack_public_path__ + "static/media/FCA_original.ae5e443e.png";